import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import { useDispatch } from "react-redux";
import { useAppSelector } from "store/hooks";
import { cancelEdition } from "../../store/expressionEditorSlice";
import ExpressionEditor from "../ExpressionEditor";
import ConfirmButton from "./ConfirmButton";

const ExpressionEditorDialog = () => {
  const { isEditing } = useAppSelector(
    (state) => state.developer.edit.expressionEditor
  );
  const dispatch = useDispatch();

  return (
    <Drawer
      open={isEditing}
      onClose={() => {
        dispatch(cancelEdition());
      }}
      anchor="right"
      PaperProps={{
        sx: {
          width: "50%",
        },
      }}
    >
      <Stack sx={{ display: "flex", flexGrow: 1 }}>
        <ExpressionEditor />
        <Stack direction="row" justifyContent="flex-end" spacing={2} p={3}>
          <Button
            onClick={() => dispatch(cancelEdition())}
            color="primary"
            size="large"
          >
            Cancel
          </Button>
          <ConfirmButton />
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default ExpressionEditorDialog;
